/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
import _regeneratorRuntime from "E:\\ysh\\wx-master\\node_modules\\_@babel_runtime@7.16.5@@babel\\runtime\\regenerator\\index.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
/*
 * @Description:
 * @Date: 2021-02-03 14:37:20
 */


import router from '@/router/index';
import { queryViewingCheckInfo, queryUserInfoAnswer, selectByInvitatioList, getCourseRela, queryliveZdyMenuList, queryChannelZhiboRaffle, queryChannelZhiboConf, queryChannelCourse, queryLiveShareCourseList, queryDrawResults, queryCourseRaffleConfigInfo, queryCheckZhiboRaffleInfi } from '@/api/course';
import { storageUserInfo } from '@/utils/storage';
/**
 * @description:    判断当前直播状态
 * @param {object}  直播详情
 * @param {object}  直播配置
 * @return {number} 1直播前 2直播中 3直播结束 4转码中 5回放 6视频
 */

var getCurrentLivingStatus = function getCurrentLivingStatus(livingDetail, livingConfig) {
  var liveStartTime = livingDetail.liveStartTime,
      liveEndTime = livingDetail.liveEndTime,
      livingUrl = livingDetail.livingUrl,
      liveStartTimeByforecast = livingDetail.liveStartTimeByforecast; // 直播前, 使用减十分钟的预告时间

  if (liveStartTimeByforecast > Date.now()) {
    return 1;
  } else {
    // 直播结束
    if (Date.now() > liveEndTime) {
      return 3;
    } else {
      // 直播中
      if (livingUrl) {
        return 2;
      }
    }
  }
};

var filterResult = function filterResult(result) {
  var defaultType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'array';
  var defaultResult = defaultType === 'array' ? [] : {};
  return result || defaultResult;
};

var state = {
  coverVideo: false,
  // 是否出现弹层，当有视频播放时需要隐藏播放器
  detail: {},
  // 课程详情
  rela: [],
  // 关联直播
  zdyMenuList: [],
  // 直播菜单
  checkInfo: {},
  // 限制信息
  isSubmitCheck: false,
  // 是否提交过限制问卷
  currentZdyMenu: {
    // 当前菜单
    type: 100,
    id: 100,
    content: ''
  },
  raffle: {},
  // 抽奖信息,无id则无抽奖 {id status type viewTime}
  livingConf: {},
  // 直播配置信息
  drawResult: {},
  // 抽奖结果
  shareList: [],
  // 邀请卡
  isRaffled: false,
  // 当前用户是否已抽奖
  raffleList: [],
  // 奖品数据
  livingStatus: 0,
  // 1直播前 2直播中 3直播结束 4转码中 5转码完成
  realUsers: 0,
  // 实时用户数
  totalUsers: 0 // 用户总次数

};
var mutations = {
  SET_COMMON: function SET_COMMON(state, data) {
    state[data.field] = data.value;
  }
};
var actions = {
  init: function () {
    var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var dispatch, commit, courseId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch = _ref.dispatch, commit = _ref.commit;
              courseId = router.currentRoute.params.id;
              _context.next = 4;
              return dispatch('setCourseDetail', courseId);

            case 4:
              // dispatch('setCourseRela', courseId);
              // dispatch('setZdyMenuList', courseId);
              // dispatch('setChekInfo', courseId);
              // dispatch('setRaffle', courseId);
              // dispatch('setZhiboConf', courseId);
              dispatch('setShareList', courseId);
              return _context.abrupt("return", Promise.resolve());

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function init(_x) {
      return _init.apply(this, arguments);
    }

    return init;
  }(),
  // 课程详情
  setCourseDetail: function () {
    var _setCourseDetail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, courseId) {
      var commit;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                queryChannelCourse({
                  id: courseId
                }).then(function (_ref3) {
                  var pdata = _ref3.pdata;
                  var detail = pdata;
                  var livingConf = pdata.courseConf;
                  var menuList = pdata.menuList,
                      watchCheck = pdata.watchCheck,
                      isWatchImpose = pdata.isWatchImpose,
                      CourseRela = pdata.CourseRela; // 自定义预告时间，使用该字段判断直播是否开始
                  // 自定义预告时间，使用该字段判断直播是否开始

                  detail.liveStartTimeByforecast = detail.liveStartTime - 1000 * 60 * 10;
                  commit('SET_COMMON', {
                    field: 'detail',
                    value: detail
                  });
                  commit('SET_COMMON', {
                    field: 'livingConf',
                    value: livingConf
                  });
                  commit('SET_COMMON', {
                    field: 'livingStatus',
                    value: getCurrentLivingStatus(detail, livingConf)
                  }); // tab
                  // menuList.unshift({
                  //   name: '聊天互动',
                  //   questionnaireId: null,
                  //   sort: -1,
                  //   type: 100,
                  //   id: 100
                  // });
                  // tab
                  // menuList.unshift({
                  //   name: '聊天互动',
                  //   questionnaireId: null,
                  //   sort: -1,
                  //   type: 100,
                  //   id: 100
                  // });

                  menuList.sort(function (a, b) {
                    return a.sort - b.sort;
                  });
                  commit('SET_COMMON', {
                    field: 'zdyMenuList',
                    value: menuList
                  });
                  commit('SET_COMMON', {
                    field: 'checkInfo',
                    value: watchCheck || {}
                  });
                  commit('SET_COMMON', {
                    field: 'isSubmitCheck',
                    value: isWatchImpose === 1
                  });
                  commit('SET_COMMON', {
                    field: 'rela',
                    value: CourseRela
                  });
                  resolve();
                });
              }));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function setCourseDetail(_x2, _x3) {
      return _setCourseDetail.apply(this, arguments);
    }

    return setCourseDetail;
  }(),
  // 课程关联直播
  setCourseRela: function () {
    var _setCourseRela = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4, courseId) {
      var commit, _yield$getCourseRela, guanLianList;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref4.commit;
              _context3.next = 3;
              return getCourseRela({
                courseId: courseId
              });

            case 3:
              _yield$getCourseRela = _context3.sent;
              guanLianList = _yield$getCourseRela.pdata.guanLianList;
              commit('SET_COMMON', {
                field: 'rela',
                value: filterResult(guanLianList)
              });
              return _context3.abrupt("return", Promise.resolve());

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function setCourseRela(_x4, _x5) {
      return _setCourseRela.apply(this, arguments);
    }

    return setCourseRela;
  }(),
  // 直播菜单
  setZdyMenuList: function () {
    var _setZdyMenuList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref5, courseId) {
      var commit, _yield$queryliveZdyMe, pdata;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref5.commit;
              _context4.next = 3;
              return queryliveZdyMenuList({
                courseId: courseId
              });

            case 3:
              _yield$queryliveZdyMe = _context4.sent;
              pdata = _yield$queryliveZdyMe.pdata; // 聊天互动 写死
              // pdata.unshift({
              //   name: '聊天互动',
              //   questionnaireId: null,
              //   sort: -1,
              //   type: 100,
              //   id: 100
              // });

              pdata = pdata.sort(function (a, b) {
                return a.sort - b.sort;
              });
              commit('SET_COMMON', {
                field: 'zdyMenuList',
                value: pdata
              });
              return _context4.abrupt("return", Promise.resolve());

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function setZdyMenuList(_x6, _x7) {
      return _setZdyMenuList.apply(this, arguments);
    }

    return setZdyMenuList;
  }(),
  // 检查是否有限制
  setChekInfo: function () {
    var _setChekInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref6, courseId) {
      var commit, _yield$queryViewingCh, pdata, info;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref6.commit;
              _context5.next = 3;
              return queryViewingCheckInfo({
                courseId: courseId
              });

            case 3:
              _yield$queryViewingCh = _context5.sent;
              pdata = _yield$queryViewingCh.pdata;
              info = pdata && pdata[0] || {};

              if (!(info.id && storageUserInfo().id)) {
                _context5.next = 9;
                break;
              }

              _context5.next = 9;
              return queryUserInfoAnswer({
                courseId: courseId,
                authId: info.id
              }).then(function (_ref7) {
                var s = _ref7.pdata;
                commit('SET_COMMON', {
                  field: 'isSubmitCheck',
                  value: (s || []).length > 0
                });
              });

            case 9:
              commit('SET_COMMON', {
                field: 'checkInfo',
                value: info
              });
              return _context5.abrupt("return", Promise.resolve());

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function setChekInfo(_x8, _x9) {
      return _setChekInfo.apply(this, arguments);
    }

    return setChekInfo;
  }(),
  // 抽奖信息
  setRaffle: function () {
    var _setRaffle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref8, courseId) {
      var commit, rootState, _yield$queryChannelZh, pdata;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref8.commit, rootState = _ref8.rootState;
              _context6.next = 3;
              return queryChannelZhiboRaffle({
                courseId: courseId
              });

            case 3:
              _yield$queryChannelZh = _context6.sent;
              pdata = _yield$queryChannelZh.pdata;
              pdata = filterResult(pdata)[0] || {};
              commit('SET_COMMON', {
                field: 'raffle',
                value: pdata
              });

              if (pdata.id) {
                // 获取奖品信息
                queryCourseRaffleConfigInfo({
                  raffleId: pdata.id,
                  courseId: courseId
                }).then(function (_ref9) {
                  var raffleList = _ref9.pdata;
                  commit('SET_COMMON', {
                    field: 'raffleList',
                    value: raffleList
                  });
                }); // 获取是否已参与抽奖

                if (rootState.user.info.id) {
                  queryCheckZhiboRaffleInfi({
                    raffleId: pdata.id,
                    userId: rootState.user.info.id
                  }).then(function (_ref10) {
                    var isRaffled = _ref10.pdata;
                    commit('SET_COMMON', {
                      field: 'isRaffled',
                      value: isRaffled ? true : false
                    });
                  });
                } else {
                  commit('SET_COMMON', {
                    field: 'isRaffled',
                    value: false
                  });
                }
              }

              return _context6.abrupt("return", Promise.resolve());

            case 9:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function setRaffle(_x10, _x11) {
      return _setRaffle.apply(this, arguments);
    }

    return setRaffle;
  }(),
  // 直播配置
  setZhiboConf: function () {
    var _setZhiboConf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref11, courseId) {
      var commit, _yield$queryChannelZh2, pdata;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              commit = _ref11.commit;
              _context7.next = 3;
              return queryChannelZhiboConf({
                courseId: courseId
              });

            case 3:
              _yield$queryChannelZh2 = _context7.sent;
              pdata = _yield$queryChannelZh2.pdata;
              return _context7.abrupt("return", Promise.resolve());

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function setZhiboConf(_x12, _x13) {
      return _setZhiboConf.apply(this, arguments);
    }

    return setZhiboConf;
  }(),
  // 邀请卡
  setShareList: function () {
    var _setShareList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref12, courseId) {
      var commit, _yield$selectByInvita, pdata;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              commit = _ref12.commit;
              _context8.next = 3;
              return selectByInvitatioList({
                courseId: courseId
              });

            case 3:
              _yield$selectByInvita = _context8.sent;
              pdata = _yield$selectByInvita.pdata;
              commit('SET_COMMON', {
                field: 'shareList',
                value: pdata || []
              });
              return _context8.abrupt("return", Promise.resolve());

            case 7:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    function setShareList(_x14, _x15) {
      return _setShareList.apply(this, arguments);
    }

    return setShareList;
  }(),
  // 触发抽奖并判断是否中奖
  onDraw: function () {
    var _onDraw = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref13) {
      var commit, state, rootState, _yield$queryDrawResul, _yield$queryDrawResul2, code, _yield$queryDrawResul3, courseRaffleConfig;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              commit = _ref13.commit, state = _ref13.state, rootState = _ref13.rootState;

              if (!rootState.user.info.id) {
                _context9.next = 20;
                break;
              }

              _context9.prev = 2;
              _context9.next = 5;
              return queryDrawResults({
                courseId: state.detail.id,
                userId: rootState.user.info.id,
                raffleId: state.raffle.id
              });

            case 5:
              _yield$queryDrawResul = _context9.sent;
              _yield$queryDrawResul2 = _yield$queryDrawResul.pdata;
              code = _yield$queryDrawResul2.code;
              _yield$queryDrawResul3 = _yield$queryDrawResul2.courseRaffleConfig;
              courseRaffleConfig = _yield$queryDrawResul3 === void 0 ? {} : _yield$queryDrawResul3;
              courseRaffleConfig.showReceive = code !== '0';
              commit('SET_COMMON', {
                field: 'drawResult',
                value: courseRaffleConfig
              });
              return _context9.abrupt("return", Promise.resolve());

            case 15:
              _context9.prev = 15;
              _context9.t0 = _context9["catch"](2);
              return _context9.abrupt("return", Promise.reject());

            case 18:
              _context9.next = 21;
              break;

            case 20:
              return _context9.abrupt("return", Promise.reject());

            case 21:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[2, 15]]);
    }));

    function onDraw(_x16) {
      return _onDraw.apply(this, arguments);
    }

    return onDraw;
  }()
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};